import { useDispatch, useSelector } from 'react-redux'
import styles from './VNTenderSelectTaxButton.module.scss'
import { centsToDollars } from '../../utils/formatters'
import { Button } from '@material-ui/core'
import useTaxResults from '../hooks/useTaxResults'
import { setManagerApprovalPrompt } from '../../VNManagerApproval/ActionCreators'
import useTaxes from '../hooks/useTaxes'
import { getIsOrderTaxExempt } from '../Selectors'
import cn from 'classnames'
import { useMemo } from 'react'

const VNTenderSelectTaxButton = () => {
  const dispatch = useDispatch()
  const { taxAmountInCents, exemptedTaxAmountInCents } = useTaxResults()
  const { exemptTax } = useTaxes()
  const taxExempt = useSelector(getIsOrderTaxExempt)

  const label = useMemo(() => {
    if (taxExempt) return `${centsToDollars(exemptedTaxAmountInCents || taxAmountInCents)} Tax Exempted`

    return `Exempt ${centsToDollars(exemptedTaxAmountInCents || taxAmountInCents)} Tax`
  }, [exemptedTaxAmountInCents, taxAmountInCents, taxExempt])

  const handleButtonClick = () => {
    if (taxExempt) return

    dispatch(setManagerApprovalPrompt({ onSuccess: exemptTax, buttonText: 'Exempt Tax' }))
  }

  return (
    <div className={cn(styles.taxButtonContainer, { [styles.disabled]: taxExempt })}>
      <Button className={cn(styles.taxButton, { [styles.disabled]: taxExempt })} disabled={taxExempt} onClick={handleButtonClick}>
        {label}
      </Button>
    </div>
  )
}

export default VNTenderSelectTaxButton
